<template>
  <van-empty v-if="msgList.length==0" />
  <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
    <template v-if="$route.query.column_type==9">
      <div class="marx10 mt10 " v-for="item in msgList" :key="item.id">
        <div class="forumlist_item pad13 radius8">
          <router-link :to="{ path: '/me/notifydetail', query: { id: item.id } }">
            <p class="forumlist__tle forumlist__tle-9"><span>{{ item.name }}<i class="reddot" v-if="item.is_read == 0"></i></span></p>
            <div class="forumlist-up">

              <div class="forumlist-up-pre">
                <img :src="item.order.thumb" class="forumlist__img forumlist__img-9" />
                <div class="forumlist-up-pre-block">
                  <p class="forumlist-goodsname a345 size18 weight ellipsis">{{ item.order.goods_name }}</p>
                  <p class="forumlist-goodsname size12 singleline">产品规格：{{ item.order.spec_key_name }}</p>
                  <p class="forumlist-goodsname size12">价格：<span class="Cred">￥{{ item.order.price }}</span></p>
                  <!-- <p class="forumlist-goodsname" v-if="item.order.order_sn != ''">订单号：{{ item.order.order_sn }}</p> -->
                  <div class="forumlist__time size10">{{ item.add_time }}</div>
                </div>
              </div>

            </div>

            <p class="forumlist__txt size10">{{ item.content }}</p>
          </router-link>
        </div>

      </div>
    </template>
    <template v-if="$route.query.column_type !=9">
      <div class="marx10 mt10" v-for="item in msgList" :key="item.id">
        <div class="forumlist_item pad13 radius8">

          <router-link :to="{ path: '/me/notifydetail', query: { id: item.id } }">
            <div class="forumlist-up">
              <div class="forumlist-up-pre">
                <img src="@/assets/img/icon13.png" class="forumlist__img" />
                <p class="forumlist__tle b500"><span>{{ item.name }}<i class="reddot" v-if="item.is_read == 0"></i></span></p>
              </div>
              <div class="forumlist__time">{{ item.add_time }}</div>
            </div>
            <p class="forumlist__txt">{{ item.content }}</p>
          </router-link>
        </div>
      </div>
    </template>
  </van-list>
</template>
  <script setup>
import { ref } from "vue";
import ajax from "@/utils/request.js";
import { useRoute } from "vue-router";

const route = useRoute();
const { query } = route;

const loading = ref(true);
const finished = ref(false);

const msgList = ref([]);
const page = ref(1);

function getMsgList () {
  const data = {
    page: page.value,
    column_type: query.column_type,
  };
  let url = "users/getmessagelist"
  return ajax.post(url, data).then((res) => {
    
    if (res.data.length < 10) {
      msgList.value = msgList.value.concat(res.data);
      finished.value = true;
    } else {
      msgList.value = msgList.value.concat(res.data);
      page.value++;
    }
  }).catch(() => {
    finished.value = true;
  })
}
getMsgList().finally(() => {
  loading.value = false;
});

const onLoad = () => {
  loading.value = true;
  getMsgList().finally(() => {
    loading.value = false;
  });
};
</script>
  <style scoped>
  .forumlist-goodsname {
    /* width: calc( 90% - 140px); */
    word-break: break-all;
  }

.forumlist_item{
  background-color: #fff;
}
.forumlist-up {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.forumlist-up-pre {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.forumlist__img {
  width: 28px;
  margin-right: 4px;
}
.forumlist__img-9 {
  width: 100px;
}
.forumlist__tle {
  font-size: 14px;
  color: #333333;
  font-weight: 700;
  font-family: 'a345';
}
.forumlist__tle-9 {
  margin-bottom: 5px;
}
.forumlist__tle span {
  position: relative;
}
.forumlist__tle span i {
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: red;
  top: 0;
  right: -4px;
}
.forumlist__time {
  font-size: 12px;
  color: #999999;
}
.forumlist__txt {
  font-size: 14px;
  color: #999999;
  margin-top: 13px;
}
.forumlist-up-pre-block {
  width: calc( 100vw - 155px );
  margin-left: 15px;
}
</style>